import React from 'react';
import PropTypes from 'prop-types';
import scrollToComponent from 'react-scroll-to-component';
import AWLogo from 'images/logo-white.svg';
import AlgoAffiliatesLogo from 'images/algo-affiliates.svg';
import { StyledWrapper } from './styles';

class Nav extends React.Component {
  scrollToSection = (ref) => {
    scrollToComponent(document.getElementById(ref), { offset: 0, align: 'top', duration: 500 });
  }
  render() {
    return (
      <StyledWrapper>
        {/* <div className="blue">
          <p>Don’t forget to enter the flip cup team raffle! <a href="https://istackconferences.typeform.com/to/N3ifvSnQ/" target="_blank" rel="noopener noreferrer">Click here to enter</a></p>
          <p>Join the flip cup team raffle! <a href="https://istackconferences.typeform.com/to/N3ifvSnQ/" target="_blank" rel="noopener noreferrer">Click here to enter</a></p>
        </div> */}
        <div className="brands">
          <span>
            <img src={AWLogo} alt="aw" /> &
            <img src={AlgoAffiliatesLogo} alt="aw" /> PRESENTS
          </span>
        </div>
      </StyledWrapper>
    );
  }
}

Nav.propTypes = {
  logo: PropTypes.bool.isRequired,
  rsvp: PropTypes.bool.isRequired,
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/index.js